import React from 'react';
import {Link} from 'react-router';
import MessageThread from './message_thread_component.jsx';
import './messages.less';
import ReactDOM from 'react-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import messageActions from './messages_action';
import EmptyMessageComponent from './empty_message_view.jsx';
import cookies from '../util/cookie';
import CONSTANTS from '../common_constants';
import $ from 'jquery';

class MessageCarryingDashboard extends React.Component {
  constructor(props){
    super(props);
    this.getCarryingMessageThreads = this.getCarryingMessageThreads.bind(this);
    this.renderMessageThread = this.renderMessageThread.bind(this);
    this.updateMessageThreads = this.updateMessageThreads.bind(this);
    this.handleScrollPagination = this.handleScrollPagination.bind(this);
    this.state = {
      isLoading: false,
      error: '',
      isCarryingPage: true
    }
  }

  renderMessageThread(messageArray) {
      if (messageArray && messageArray.length > 0) {
          return messageArray.map((message, index) => (<MessageThread key={index} message={message} />));
      }
  }


getCarryingMessageThreads(){
  let isShipping = 1;
  let pageCount = 50;
  let timestamp = 0;
  const {props} = this;

  const url_params = {
      isShipping: isShipping,
      count: pageCount,
      timestamp: timestamp
  }
  // loader
  this.setState({isLoading: true});

  // api call
  props.actions.getMessageThread(url_params).then((data) => {
       // loader
        this.setState({isLoading: false
        })

  }, (error) => {

    if(error.error === CONSTANTS.sessionInvalid){

      this.setState({isLoading: false})
      this.props.authActions.sessionValid(false);
      cookies.delete('_sd');
      return ;
    }else{
      this.setState({
        isLoading: false,
        error: error.error
      });
    }
  })
}

updateMessageThreads(nextUrl){

  const {props} = this;
  let isShipping = 1;

  if(nextUrl == '' || nextUrl == null || nextUrl == undefined){
    return
  }

  const url_params = {
    isShipping: isShipping,
    nextUrl: nextUrl
  }

  // loader
  this.setState({isLoading: true})

  // api call
  props.actions.updateMessageThreads(url_params).then((data) => {
    // loader
    this.setState({isLoading: false});

  }, (error) => {
     if(error.error === CONSTANTS.sessionInvalid){

       this.setState({isLoading: false})
       this.props.authActions.sessionValid(false);
       cookies.delete('_sd');
       return ;
     }else{
       this.setState({
         isLoading: false,
         error: error.error
       });
     }
  })
}

handleScrollPagination(){
    const {props, state} = this;
    const self = this;
    let nextUrl;
    // get next url
    (props.messages.carrierMessages) ? (nextUrl = props.messages.carrierMessages.nextUrl) : (nextUrl = null);

    if( (nextUrl != '' || nextUrl != null || nextUrl != undefined) &&  !state.isLoading ){
      this.updateMessageThreads.bind(self, nextUrl)();
    }
    else{
      return;
    }
}


componentDidMount(){
  const self = this;
  // api call
  this.getCarryingMessageThreads();

  $(window).scroll( ()=>{
    this.handleScrollPagination();
  })
}

// unbind the component so that it doesn't cause the state issue
componentWillUnmount() {
   $(window).unbind("scroll");
}

renderMessageThread(messageArray) {
    if (messageArray && messageArray.length > 0) {
        return messageArray.map((message, index) => (<MessageThread key={index} message={message} agentType="carrier"/>));
    }
}

componentWillReceiveProps(newProps) {
  if (newProps.messages) this.setState({messages: newProps.messages});
}

render(){
    const {state, props} = this;
    const self = this;
    let messageArray = [];
    let nextUrl;
    let messageThreads = [];
    let shipperNavClass;
    let carrierNavClass;
    let receiverNavClass;
    let shippingCount = props.messages.shippingCount;
    let carryingCount = props.messages.carryingCount;
    let receivingCount = props.messages.receivingCount;
    let enableLoadMore = false;

    (state.isCarryingPage) ? (carrierNavClass = 'active-nav-class', shipperNavClass = 'inactive-nav-class', receiverNavClass = 'inactive-nav-class') : (carrierNavClass='inactive-nav-class');

    (props.messages.carrierMessages) ? (messageArray = props.messages.carrierMessages.messages, nextUrl = props.messages.carrierMessages.nextUrl) : (messageArray = null, nextUrl = null);
    (messageArray) ? (messageThreads = this.renderMessageThread(messageArray)) : (messageThreads = null);

    return(
       <div  ref="messageThreadWrap">
         <div className="message-tab-view-wrp">
           <div className="wrapper">
             <Link className="message-tab-elm" to = "/inbox/i-am-shipping" >
               <div className={shipperNavClass} >
                 <span>I'M SHIPPING</span>
                 {shippingCount>0 && <span className = "message-count">{shippingCount}</span>}
               </div>
             </Link>
             <Link className="message-tab-elm" to = "/inbox/i-am-carrying" >
               <div className={carrierNavClass} >
                 <span>I'M CARRYING</span>
                 {carryingCount>0 && <span className = "message-count">{carryingCount}</span>}
               </div>
             </Link>
             <Link className="message-tab-elm" to = "/inbox/i-am-receiving" >
               <div className={receiverNavClass} >
                 <span>I'M RECEIVING</span>
                 {receivingCount>0 && <span className = "message-count">{receivingCount}</span>}
               </div>
             </Link>
           </div>
           </div>
           {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
           {state.error && <ShowError errorMessage={state.error}/>}
             <div className="message-thread-wrap">
               {messageThreads}
               {!messageThreads && <EmptyMessageComponent /> }
             </div>
       </div>
     )
  }
}

MessageCarryingDashboard = connect((state) => {
  return {
    messages: state.app.messages,
    authState: state.app.auth
  }
}, (dispatch)=> {
  return {
    actions: bindActionCreators(messageActions, dispatch)
  }
})(MessageCarryingDashboard);

export default MessageCarryingDashboard;



// WEBPACK FOOTER //
// app/messages/message_carrying_dashboard.jsx